export class RuleCondition {
    public RuleId: number;
    public Position: number;
    public RuleConditionParamName: string;
    public RuleConditionDesc: string;
    public ConditionId: number;
    public RuleConditionParamValue: string;
}
